import Api from "../../../../services/Api";

function fetchEnergyConsumption(siteId, startTime, endTime, chargerId) {
  return Api.get(
    `service/iqevse-csms/v1/evse/timeseries/day_wise_stats?site_id=${siteId}&start_date=${startTime}&serial_num=${chargerId}&end_date=${endTime}&is_power=true&bin_width=300`
  );
}

export { fetchEnergyConsumption };
